export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT INSIDE DINING.29130633.jpg";